import React from "react";
import "./App.css";
import Main from "./pages/main.pages";

function App() {
  return (
    <div className="app">
      <Main />
    </div>
  );
}

export default App;
